import Parse from "helpers/parse";

export class StringToIntegerValueConverter {
    public fromView(value: any): string | null {
        return Parse.NullableString(value);
    }

    public toView(value: any): number | null {
        return Parse.NullableInteger(value);
    }
}
